<template>
  <div class="search-result">
    <search-sport v-for="sport in sports" :key="sport.id" :sport="sport">
      <search-league v-for="league in sport.leagues" :key="league.id" :sport="sport.id" :league="league">
        <search-event
          class="event"
          v-for="event in league.events"
          :key="event.id"
          :event="event"
          @click="open = false; query = ''; $router.push(`/prematch/sport/${sport.id}/event/${event.id}`);" />
      </search-league>
    </search-sport>
  </div>
</template>

<script>
import SearchSport from '@/components/header/SearchSport'
import SearchLeague from '@/components/header/SearchLeague'
import SearchEvent from '@/components/header/SearchEvent'

export default {
  components: { SearchSport, SearchLeague, SearchEvent },
  props: {
    sports: Object
  }
}
</script>



// WEBPACK FOOTER //
// src/components/header/SearchResult.vue